module.exports = __webpack_public_path__ + "static/media/residencia_medica.fc9a481b.jpg";